<template>
  <!-- <v-toolbar class="toolbar-bg" dark app clipped-left fixed> -->
  <v-app-bar :class="toolbarColor" dark app clipped-left fixed>
    <v-app-bar-nav-icon @click.stop="toggleMenu" id="leftMenu"></v-app-bar-nav-icon>
    <v-app-bar-title style="width: 250px">
      <router-link :to="{ name: 'dashboard' }" class="brandlogo" id="logo">
        {{ mainTitle }}
      </router-link>
    </v-app-bar-title>
    <search propclass="hidden-sm-and-down"></search>
    <v-spacer></v-spacer>
    <v-btn icon class="hidden-md-and-up" @click="toggleSearch">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
    <!--
      Open only if the feature is usable
      <v-btn icon @click="openDBSearch">
        <v-icon>mdi-database-search</v-icon>
      </v-btn>
    -->
    <v-menu offset-y :close-on-content-click="false" v-model="notification" light left>
      <template v-slot:activator="{ on }">
        <v-btn v-if="isBatchManager === true" icon v-on="on" id="notificationBtn" dark @click="toBch()">
          <v-icon>mdi-clock</v-icon>
          <v-badge right color="red" overlap v-if="hasBchNotification">
            <span class="badge-font-size" slot="badge" >{{ batchCount }}</span>
          </v-badge>
        </v-btn>
        <v-btn icon v-on="on" id="notificationBtn" dark @click="toRpt()">
          <v-icon>mdi-printer</v-icon>
          <v-badge right color="red" overlap v-if="hasRptNotification">
            <span class="badge-font-size" slot="badge" >{{ reportCount }}</span>
          </v-badge>
        </v-btn>
        <v-btn icon v-on="on" id="notificationBtn" dark @click="toMsg()">
          <v-icon>mdi-email</v-icon>
          <v-badge right color="red" overlap v-if="hasMsgNotification">
            <span class="badge-font-size" slot="badge">{{ messageCount }}</span>
          </v-badge>
        </v-btn>
      </template>
    </v-menu>
    <v-menu offset-y light left>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" id="userSettingsBtn" dark>
          <v-avatar size="40px" :color="getAvatarColor($store.getters.userId)">
            <span class="white--text avatarText">{{ $store.getters.userInitials }}</span>
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="subheading font-weight-strong teal--text">{{ this.$store.getters.userFullName }}</v-list-item-title>
              <v-list-item-title>
                <span class="caption grey--text font-weight-light">
                  ({{ this.$store.state.token.userBranch }} - {{ this.$store.getters.userRoles }})
                </span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="teal">mdi-account-check</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="$router.push({ name: 'profile' })">
            <v-list-item-content>
              <v-list-item-title>User Settings</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-account-settings-variant</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item @click="doLogout">
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import Search from './search/Search'
// import NotifList from '../misc/notification/NotifList'
import { APP_TOGGLE_MENU, APP_TOGGLE_SEARCH } from '@/store/types'
import { setCookie } from '@/utils/cookie'
import { getAvatarColor } from '@/utils/global'

export default {
  data() {
    return {
      notification: false
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    notifications() {
      return this.$store.state.user.notification
    },
    toolbarColor() {
      // For top bar, I feel a darker color looks nicer
      return this.$store.getters.toolbarColor
    },
    mainTitle() {
      return this.$store.state.app.projectTitle
    },
    hasRptNotification() {
      return (
        (this.notifications.rptJobCount !== undefined && this.notifications.rptJobCount > 0)
      )
    },
    hasMsgNotification() {
      return (
        (this.notifications.newCount !== undefined && this.notifications.newCount > 0) ||
        (this.notifications.draftCount !== undefined && this.notifications.draftCount > 0)
      )
    },
    hasBchNotification() {
      return (
        (this.notifications.bchJobCount !== undefined && this.notifications.bchJobCount > 0)
      )
    },
    batchCount() {
      if (this.notifications.bchJobCount > 99) {
        return '99+'
      } else {
        return this.notifications.bchJobCount
      }
    },
    reportCount() {
      if (this.notifications.rptJobCount > 99) {
        return '99+'
      } else {
        return this.notifications.rptJobCount
      }
    },
    messageCount() {
      let count = this.notifications.newCount + this.notifications.draftCount
      if (count > 99) {
        return '99+'
      } else {
        return count
      }
    },
    isBatchManager() {
      return this.$store.state.app.dataMap.isBatchManager
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('initNotification')])
    },
    toBch() {
      this.$router.push({ name: 'notifBatches' })
    },
    toRpt() {
      this.$router.push({ name: 'notifReports' })
    },
    toMsg() {
      this.$router.push({ name: 'notifMessages', params: { msgType: 'inbox' } })
    },
    toggleMenu() {
      this.$store.commit(APP_TOGGLE_MENU)
      // For user manual trigger, save the state to cookie
      if (this.$store.state.app.toggleMenu) {
        setCookie('menu', true)
      } else {
        setCookie('menu', false)
      }
    },
    toggleSearch() {
      this.$store.commit(APP_TOGGLE_SEARCH)
    },
    doLogout() {
      this.$store.dispatch('logout', true)
    },
    openDBSearch() {
      this.$store.dispatch('dataSearchOpen')
    },
    doClose() {
      this.notification = false
    },
    getAvatarColor(userId) {
      return getAvatarColor(userId)
    }
  },
  components: {
    Search
    // NotifList
  }
}
</script>

<style lang="scss">
.brandlogo {
  color: #fff !important;
  text-decoration: none;
  font-size: 18px !important;
}
.avatarText {
  font-size: 20px !important;
  font-weight: 500;
  line-height: 32px !important;
  letter-spacing: normal !important;
}
.badge-font-size {
  font-size: 9px;
}
.v-app-bar-title__content {
  width: 200px;
}
</style>
